<template>
  <portal to="gamblePagePortal" v-if="show">
    <div class="comp-container" @click="close">
      <!-- <div class="pop-content-box" @click.stop> -->
      <div class="pop-box" v-if="showBox" @click.stop>
        <div class="box-top" v-if="boxType == 'title'">
          <div class="title"><i class="icon-logo-color icon" />{{ title }}</div>
          <div class="close close-btn" @click="close"></div>
        </div>
        <div class="content">
          <div class="top-line" v-if="boxType == 'title'"></div>
          <div class="slot" :class="boxType == 'box' ? 'no-title' : ''">
            <slot></slot>
          </div>
        </div>
      </div>
      <slot v-if="!showBox"></slot>
      <!-- </div> -->
    </div>
  </portal>
</template>

<script>
export default {
  name: "gamblePageNav",
  props: {
    show: {},
    title: {},
    boxType: {}, //title ,box ,noBox
  },
  data() {
    return {};
  },
  computed: {
    showBox() {
      return ["title", "box"].includes(this.boxType);
    },
  },
  watch: {},
  methods: {
    close() {
      // console.log(123123);
      this.$emit("update:show", false);
      this.$emit("close");
    },
  },
  components: {},
  mounted() {},
  created() {
    if (this.boxType == "box") {
      setTimeout(() => {
        this.close();
      }, 5 * 1000);
    }
  },
};
</script>

<style lang="scss" scoped>
.comp-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;

  .pop-content-box {
    // width:0;
    // height: 0;
  }
  .pop-box {
    min-height: 3.55rem;
    min-width: 6.73rem;
    border: 0.01rem solid #fff;
    /* background-image: -webkit-linear-gradient(
      bottom,
      rgba(121, 122, 124, 1),
      rgba(67, 68, 72, 0.8) 40%
    ); */
    background-image: -webkit-linear-gradient(
      bottom,
      rgba(#14263c, 0.8),
      rgba(#17202f, 0.8) 40%
    );

    display: flex;
    flex-direction: column;

    .box-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.08rem;

      .title {
        font-size: 0.26rem;
        color: #fff;
        display: flex;
        align-items: center;
        margin-left: 0.1rem;
        .icon {
          font-size: 0.35rem;
        }
      }
      .close {
        font-size: 0.44rem;
      }
    }
    .content {
      padding: 0 0.18rem;
      flex: 1;
      display: flex;
      flex-direction: column;

      .top-line {
        height: 0.01rem;
        width: 100%;
        border: solid #fff;
        border-width: 0 0.06rem;
        background-color: #656564;
      }
      .slot {
        margin-top: 0.2rem;
        flex: 1;
        position: relative;
        &.no-title {
          margin-bottom: 0.2rem;
        }
      }
    }
  }

  .text {
    width: 100px;
    height: 100px;
    background-color: #fff;
  }
}
</style>
